import React from 'react';

import {
  TpHoverInfo,
  TpHoverRenderContext,
  TpHoverRenderInfo,
  ZoomPanCanvas,
} from '../../zoompan-canvas/ZoomPanCanvas';
import { TpZoomPanelInvPointMapInfo } from '../../zoompan-canvas/zoomPanCanvasHelpers';
import { TpChartProps } from '../interfaces';
import { createDefinition } from './longitNumerical.Renderer';
import { ChartFilterButton, convertColumnDataToDisplayString } from '../../helpers/misc';

export function LongitNumerical({ chartTypeManifest, dataContext, dataBinding, config, widgetContext }: TpChartProps) {
  const widgetGlobalConfig = widgetContext.dashboardContext.widgetGlobalConfig ?? {};
  const {
    definition,
    areaPoints,
    dataTable,
    samples,
    getSampleItemIndexById,
    customHoverRenderer,
    colInfoSampleHoverLabel,
    dataSampleHoverLabel,
    nameY,
    colInfoPointY,
    dataPointY,
    title,
  } = createDefinition(chartTypeManifest, dataContext, dataBinding, config, widgetGlobalConfig);

  const filterInfo = false;

  function getHoverInfo(
    mappingInfo: TpZoomPanelInvPointMapInfo,
    logicPositX: number,
    logicPositY: number,
    renderPositX: number,
    renderPositY: number,
  ): TpHoverInfo | null {
    if (mappingInfo.area?.id != 'points') return null;
    let minDist = mappingInfo.mapsize(10);
    let selSampleId = null;
    let hoverCentX = null;
    let hoverCentY = null;
    let pointIdx = null;
    for (const sample of samples) {
      for (const point of sample.points) {
        const scr_x = mappingInfo.mapX.map(point.x);
        const scr_y = mappingInfo.mapY.map(point.y);
        const dst = Math.abs(scr_x - renderPositX) + Math.abs(scr_y - renderPositY);
        if (dst <= minDist) {
          selSampleId = sample.sampleId;
          pointIdx = point.pointIdx;
          minDist = dst;
          hoverCentX = point.x;
          hoverCentY = point.y;
        }
      }
    }
    if (selSampleId == null) return null;
    return {
      dataTableId: dataBinding.dataTableId,
      itemId: selSampleId,
      custom: { hoverCentX, hoverCentY, pointIdx },
    };
  }

  function getHoverRenderInfo(hoverInfo: TpHoverInfo, context: TpHoverRenderContext): TpHoverRenderInfo | null {
    if (hoverInfo.dataTableId != dataBinding.dataTableId || hoverInfo.catColumnId) return null;
    if (hoverInfo.itemId == null) return null;
    const hoverItemNr = getSampleItemIndexById(hoverInfo.itemId);
    if (hoverItemNr === undefined) return null;
    const labels: string[] = [];
    if (context.isActiveChart) {
      if (dataSampleHoverLabel)
        labels.push(convertColumnDataToDisplayString(colInfoSampleHoverLabel, dataSampleHoverLabel[hoverItemNr]));
      if (hoverInfo.custom)
        labels.push(
          `${nameY}=${convertColumnDataToDisplayString(colInfoPointY, dataPointY[hoverInfo.custom!.pointIdx])}`,
        );
    }
    return {
      area: areaPoints,
      logicPosX: context.isActiveChart ? hoverInfo.custom?.hoverCentX : null,
      logicPosY: context.isActiveChart ? hoverInfo.custom?.hoverCentY : null,
      labels,
      customHoverRenderer,
    };
  }

  function onItemClicked(itemId: string) {
    widgetContext.handleOpenItem(dataTable.canonicalTypeId, itemId);
  }

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <ZoomPanCanvas
        definition={definition}
        getHoverInfo={getHoverInfo}
        getHoverRenderInfo={getHoverRenderInfo}
        onItemClicked={onItemClicked}
        maxZoomXRelative={30}
        maxZoomYRelative={30}
        widgetContext={widgetContext}
        chartTitleInfo={{
          assetId: dataContext.assetId,
          dataType: chartTypeManifest.id,
          title,
        }}
      />
      {filterInfo && <ChartFilterButton />}
    </div>
  );
}
